import React, { useEffect } from 'react';
import { PRIVACY_PUBLIC } from 'utils/Constants';
import { AuthDialog } from 'components/AuthDialog/AuthDialog';
import { clearAddSpot } from 'store/slices/newSpot';
import { clearDrafts } from 'store/slices/spotDrafts';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import Box from '@mui/material/Box';
import ErrorMessage from '../ErrorMessage';

const AddSpotFinished = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();

    useEffect(() => {
        dispatch(clearDrafts());
    }, []);

    const newSpot = useAppSelector((state) => state.newSpot);
    const { privacy } = newSpot;
    const submittingSpot = false;
    const submittingSpotError = false;
    const submittingSpotSuccess = true;

    return (
        <AuthDialog
            title={'Create a New Spot'}
            onClose={() => {
                dispatch(clearAddSpot());
                history.push('/');
            }}
        >
            <Box>
                {submittingSpot ?
                    <Box sx={{
                        textAlign: 'center'
                    }}
                    >
                        <Typography variant={'h4'}>Submitting your spot...</Typography>
                    </Box> : null}
                {!submittingSpot && submittingSpotError ?
                    <Box>
                        <ErrorMessage
                            specificError={'Oops! Something went wrong while submitting your spot.'}
                        />
                    </Box> : null}
                {!submittingSpot && submittingSpotSuccess ? <Box>
                    {privacy === PRIVACY_PUBLIC ? (
                        <Typography variant={'body1'} mb={2}>
                            🎉 Congrats! Your spot has been added. Once it's approved, others will be able to see it too!
                        </Typography>
                    ) : (
                        <Typography variant={'body1'} mb={2}>
                            🎉 Your spot has been added! You can now see it on your map.
                        </Typography>
                    )}
                </Box> : null}
            </Box>
        </AuthDialog>
    );
};

export default AddSpotFinished;
